module.exports = __webpack_public_path__ + "assets/60RotationCW.313585cc9a966673ef7825261a9509bb.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/60RotationCW.gmt
// module id = 882
// module chunks = 0